import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalCookiesComponent } from '../modal-cookies/modal-cookies.component';

@Component({
  selector: 'app-modal-privacy-policy',
  templateUrl: './modal-privacy-policy.component.html',
  styleUrls: ['./modal-privacy-policy.component.scss']
})
export class ModalPrivacyPolicyComponent {
  constructor(private dialogRef: MatDialogRef<ModalPrivacyPolicyComponent>, private dialogCookies: MatDialog) {}

  closeModal(): void {
    this.dialogRef.close();
  }

  openCookies(): void {
    this.dialogRef.close();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      disableClose: true,
      autoFocus: false,
      panelClass: ['modal__full-screen']
    };
    this.dialogCookies.open(ModalCookiesComponent, dialogConfig.data);
  }
}
